import { Fragment, useRef, useEffect } from 'react';
import { formatNumber } from '../utils/stats';
import './MessageList.css';

const MessageList = ({ messages, isGenerating, botHistory, insightsOpen, insightsTab, selectedEntry, onToggleTokens }) => {
    const listRef = useRef(null);

    useEffect(() => {
        listRef.current?.scrollTo(0, listRef.current.scrollHeight);
    }, [messages]);

    return (
        <div className="ai_chat_panel_messages" ref={listRef}>
            {messages.length === 0 &&
                <div className="ai_chat_panel_empty">Describe the bot you want and Teia will generate the blocks for you.</div>
            }
            {messages.map((message, index) =>
                <Fragment key={index}>
                    <div className={"ai_chat_panel_bubble " + message.role}>{message.text}</div>
                    {message.stats &&
                        <button
                            type="button"
                            className={"ai_chat_panel_tokens" + (insightsOpen && insightsTab === 'usage' && selectedEntry && selectedEntry.id === message.historyId ? " active" : "")}
                            disabled={!botHistory.some((entry) => entry.id === message.historyId)}
                            title={botHistory.some((entry) => entry.id === message.historyId) ? "Show the AI usage details for this answer" : "This answer was removed from the history"}
                            onClick={() => onToggleTokens(message.historyId)}
                        >
                            <i className="fas fa-info-circle"></i> {formatNumber(message.stats.total_tokens)} tokens
                        </button>
                    }
                </Fragment>
            )}
            {isGenerating &&
                <div className="ai_chat_panel_bubble assistant">Teia is thinking...</div>
            }
        </div>
    );
};

export default MessageList;
